<template>
  <div class="row">
    <div class="col-md-12" v-for="url in urls">
      <div class="box box-primary">
        <div class="overlay" v-if="url.loading">
          <i class="fa fa-refresh fa-spin"></i>
        </div>
        <div class="box-header with-border">
          <h3 class="box-title">{{ url.title }}</h3>
          <button class="btn btn-default btn-xs pull-right"
                  @click.prevent="getAvertissement(url.url,true)">
            <i class="fa fa-refresh "></i>
          </button>
        </div>
        <div class="box-body">
          <table class="table table-hover table-responsive">
            <thead>
            <tr>
              <th>Licence</th>
              <th>Nom</th>
              <th>Prenom</th>
              <th>Club</th>
              <th>Statut</th>
              <th>Compétition</th>
            </tr>
            </thead>
            <tbody>
            <tr v-for="result in url.result">
              <td>
                <router-link :to="{ name: 'Member', params: { member_id: result.membre.id }}">
                  {{ result.membre.numlicenceABFT }}
                </router-link>
              </td>
              <td>
                <router-link :to="{ name: 'Member', params: { member_id: result.membre.id }}">
                  {{ result.membre.nom }}
                </router-link>
              </td>
              <td>
                <router-link :to="{ name: 'Member', params: { member_id: result.membre.id }}">
                  {{ result.membre.prenom }}
                </router-link>
              </td>
              <td>
                <router-link v-if="result.membre.licence_active.length>0 && result.membre.licence_active[0].club"
                             :to="{ name: 'Club', params: { club_id: result.membre.licence_active[0].club.id }}">
                  {{ result.membre.licence_active[0].club.club }}
                </router-link>
                <span v-if="result.membre.licence_active.length==0">-</span>
              </td>
              <td>Dernière licence valable jusqu'au {{ getLastLicence(result.membre.licences).date_fin }}</td>
              <td>
                <router-link :to="{ name: 'Competition', params: { competition_id: result.id_compet }}">
                  {{ result.competition.competition }}
                </router-link>
              </td>
            </tr>
            </tbody>
          </table>

        </div>
      </div>
    </div>
  </div>
</template>


<script>
import {mapGetters, mapActions} from 'vuex'

var _ = require('lodash')

var moment = require('moment')

export default {
  data() {
    return {
      urls: {
        competitorsWithoutClub: {
          loading: false,
          url: "competitorsWithoutClub",
          title: "Compétiteurs n'ayant pas de club lors d'une compétition",
          result: [],
        },
        participationsWithEncodageErrors: {
          loading: false,
          url: "participationsWithEncodageErrors",
          title: "Compétiteurs avec des erreurs d'encodage",
          result: [],
        },
        participationsWithoutLicenceActive: {
          loading: false,
          url: "participationsWithoutLicenceActive",
          title: "Compétiteurs n'étant pas licenciés lors de la compétition",
          result: [],
        },
      },
    }
  },
  props: {},
  computed: {
    ...mapGetters({
      getRoute: 'getRoute',
    }),

  },
  mounted: function () {
    _.each(this.urls, item => {
      this.getAvertissement(item.url);
    })
    // this.urls.forEach(item => {
    //     this.getAvertissement(item.url);
    // })
  },
  methods: {
    ...mapActions({
      setRecap: 'setRecap',
    }),
    getAvertissement: function (url, forceCache = false) {
      let self = this;
      this.urls[url].loading = true
      self.$http.get(this.getRoute('Avertissement.' + url), {
        params: {
          forceCache: forceCache
        }
      }).then((response) => {
        this.urls[url].result = response.body
        this.urls[url].loading = false
      }, (response) => {
      });
    },
    getLastLicence: function (licences) {
      return _.sortBy(licences, (licence) => {
        return new Date(this.$formatDate(licence.date_fin, "DD/MM/YYYY", "YYYY-MM-DD hh:mm:ss"));
      }).reverse()[0]
    }
  },
  beforeRouteUpdate(to, from, next) {
  },

  beforeRouteEnter(to, from, next) {
  },
  watch: {},
  components: {}
}
</script>



// WEBPACK FOOTER //
// src/components/Secretariat/Avertissement/Avertissement_ranking.vue